import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AccountFlagsFlowInterface, AccountFlagsFlowStateType, AccountFlagsFlowErrorType } from '@central-products/interface-account-flags-flow';
import { ACCOUNT_EVENT_IDS } from '@central-products/interface-account-actions';
import { FLAGS_CONFIG, INFO_FLAGS_CONFIG } from './constants';
import { AccountFlagsContainer } from './AccountFlagsContainer';
import './index.scss';
export var AccountFlagsFlow = /*#__PURE__*/function (_AccountFlagsFlowInte) {
  _inherits(AccountFlagsFlow, _AccountFlagsFlowInte);

  var _super = _createSuper(AccountFlagsFlow);

  function AccountFlagsFlow(config, dependencies) {
    var _this;

    _classCallCheck(this, AccountFlagsFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", AccountFlagsFlowStateType.NONE);

    _defineProperty(_assertThisInitialized(_this), "onStateChangedCallback", void 0);

    _defineProperty(_assertThisInitialized(_this), "domNode", null);

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(AccountFlagsFlow, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
        var _window$performance, _window$performance$m;

        var isFlagSupported;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!INFO_FLAGS_CONFIG[this.config.jurisdiction].includes(payload.flag)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", {});

              case 2:
                if (!(this.state !== AccountFlagsFlowStateType.NONE)) {
                  _context2.next = 4;
                  break;
                }

                throw {
                  error: AccountFlagsFlowErrorType.INVALID_STATE
                };

              case 4:
                isFlagSupported = FLAGS_CONFIG[this.config.jurisdiction].hasOwnProperty(payload.flag);

                if (isFlagSupported) {
                  _context2.next = 7;
                  break;
                }

                throw {
                  error: AccountFlagsFlowErrorType.INVALID_STATE
                };

              case 7:
                (_window$performance = window.performance) === null || _window$performance === void 0 ? void 0 : (_window$performance$m = _window$performance.mark) === null || _window$performance$m === void 0 ? void 0 : _window$performance$m.call(_window$performance, 'cp:account-flags:start');
                this.render(payload);
                this.setState(AccountFlagsFlowStateType.STARTED);
                return _context2.abrupt("return", {});

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "cancel",
    value: function () {
      var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.state === AccountFlagsFlowStateType.NONE || this.domNode === null)) {
                  _context3.next = 2;
                  break;
                }

                throw {
                  error: AccountFlagsFlowErrorType.INVALID_STATE
                };

              case 2:
                ReactDOM.unmountComponentAtNode(this.domNode);
                document.body.removeChild(this.domNode);
                this.domNode = null;
                this.setState(AccountFlagsFlowStateType.NONE);
                return _context3.abrupt("return", {});

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function cancel() {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", {
                  state: this.state
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.onStateChangedCallback = callback;
    }
  }, {
    key: "render",
    value: function render(payload) {
      var _this2 = this;

      this.domNode = document.createElement('div');
      document.body.appendChild(this.domNode);
      var flagConfig = FLAGS_CONFIG[this.config.jurisdiction][payload.flag];

      var onClose = function onClose() {
        _this2.dependencies['account-actions'].execute({
          eventId: ACCOUNT_EVENT_IDS.ACCOUNT_FLAG_CLOSE_REQUESTED,
          context: {
            data: {
              flag: payload.flag,
              type: flagConfig.type
            },
            userFlow: 'account-flags'
          }
        });

        _this2.cancel();
      };

      var onSuccess = function onSuccess() {
        _this2.dependencies['account-actions'].execute({
          eventId: ACCOUNT_EVENT_IDS.ACCOUNT_FLAG_SUCCESS_REQUESTED,
          context: {
            data: {
              flag: payload.flag,
              type: flagConfig.type
            },
            userFlow: 'account-flags'
          }
        });

        _this2.cancel();
      };

      var onQuit = function onQuit() {
        _this2.dependencies['account-actions'].execute({
          eventId: ACCOUNT_EVENT_IDS.ACCOUNT_FLAG_QUIT_REQUESTED,
          context: {
            data: {
              flag: payload.flag,
              type: flagConfig.type
            },
            userFlow: 'account-flags'
          }
        });

        _this2.cancel();
      };

      var onLoginRequested = function onLoginRequested() {
        _this2.dependencies['account-actions'].execute({
          eventId: ACCOUNT_EVENT_IDS.LOGIN_REQUESTED,
          context: {
            userFlow: 'account-flags'
          }
        });

        _this2.cancel();
      };

      var onActionRequested = function onActionRequested(eventId, context) {
        var isCloseRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _this2.dependencies['account-actions'].execute({
          eventId: eventId,
          context: _Object$assign({}, context, {
            userFlow: 'account-flags'
          })
        });

        if (isCloseRequired) {
          _this2.cancel();
        }
      };

      var executeLogin = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(token) {
          var successEvent, _error$error, _error$error2;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (token) {
                    _context5.next = 3;
                    break;
                  }

                  onLoginRequested();
                  return _context5.abrupt("return");

                case 3:
                  _context5.prev = 3;
                  _context5.next = 6;
                  return _this2.dependencies['session-manager'].tokenLogIn({
                    token: token
                  });

                case 6:
                  successEvent = FLAGS_CONFIG[_this2.config.jurisdiction][payload.flag].successEvent;

                  if (successEvent) {
                    _context5.next = 9;
                    break;
                  }

                  return _context5.abrupt("return");

                case 9:
                  _this2.dependencies['account-actions'].execute({
                    eventId: successEvent,
                    context: {
                      userFlow: 'account-flags'
                    }
                  });

                  _context5.next = 15;
                  break;

                case 12:
                  _context5.prev = 12;
                  _context5.t0 = _context5["catch"](3);

                  if ((_context5.t0 === null || _context5.t0 === void 0 ? void 0 : (_error$error = _context5.t0.error) === null || _error$error === void 0 ? void 0 : _error$error.code) === 'error.authentication.hard.flag') {
                    _this2.dependencies['account-actions'].execute({
                      eventId: ACCOUNT_EVENT_IDS.HARD_FLAG_REQUESTED,
                      context: {
                        data: _context5.t0 === null || _context5.t0 === void 0 ? void 0 : (_error$error2 = _context5.t0.error) === null || _error$error2 === void 0 ? void 0 : _error$error2.data,
                        userFlow: 'account-flags'
                      }
                    });
                  } else {
                    onLoginRequested();
                  }

                case 15:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[3, 12]]);
        }));

        return function executeLogin(_x2) {
          return _ref.apply(this, arguments);
        };
      }();

      ReactDOM.render( /*#__PURE__*/React.createElement(AccountFlagsContainer, {
        environment: this.config.environment,
        jurisdiction: this.config.jurisdiction,
        locale: this.config.locale,
        dataAccessService: this.dependencies['data-access-service'],
        flag: {
          source: payload.flag,
          context: payload.context,
          name: flagConfig.app,
          type: flagConfig.type,
          token: payload.token,
          settings: flagConfig.settings,
          options: flagConfig.options
        },
        onClose: onClose,
        onSuccess: onSuccess,
        onQuit: onQuit,
        onLoginRequested: onLoginRequested,
        onActionRequested: onActionRequested,
        executeLogin: executeLogin
      }), this.domNode);
    }
  }, {
    key: "setState",
    value: function setState(state) {
      if (this.state === state) {
        return;
      }

      this.state = state;

      if (this.onStateChangedCallback) {
        this.onStateChangedCallback({
          state: state
        });
      }
    }
  }]);

  return AccountFlagsFlow;
}(AccountFlagsFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9BY2NvdW50RmxhZ3NGbG93LnRzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIlJlYWN0RE9NIiwiQWNjb3VudEZsYWdzRmxvd0ludGVyZmFjZSIsIkFjY291bnRGbGFnc0Zsb3dTdGF0ZVR5cGUiLCJBY2NvdW50RmxhZ3NGbG93RXJyb3JUeXBlIiwiQUNDT1VOVF9FVkVOVF9JRFMiLCJGTEFHU19DT05GSUciLCJJTkZPX0ZMQUdTX0NPTkZJRyIsIkFjY291bnRGbGFnc0NvbnRhaW5lciIsIkFjY291bnRGbGFnc0Zsb3ciLCJjb25maWciLCJkZXBlbmRlbmNpZXMiLCJOT05FIiwicGF5bG9hZCIsImp1cmlzZGljdGlvbiIsImluY2x1ZGVzIiwiZmxhZyIsInN0YXRlIiwiZXJyb3IiLCJJTlZBTElEX1NUQVRFIiwiaXNGbGFnU3VwcG9ydGVkIiwiaGFzT3duUHJvcGVydHkiLCJ3aW5kb3ciLCJwZXJmb3JtYW5jZSIsIm1hcmsiLCJyZW5kZXIiLCJzZXRTdGF0ZSIsIlNUQVJURUQiLCJkb21Ob2RlIiwidW5tb3VudENvbXBvbmVudEF0Tm9kZSIsImRvY3VtZW50IiwiYm9keSIsInJlbW92ZUNoaWxkIiwiY2FsbGJhY2siLCJvblN0YXRlQ2hhbmdlZENhbGxiYWNrIiwiY3JlYXRlRWxlbWVudCIsImFwcGVuZENoaWxkIiwiZmxhZ0NvbmZpZyIsIm9uQ2xvc2UiLCJleGVjdXRlIiwiZXZlbnRJZCIsIkFDQ09VTlRfRkxBR19DTE9TRV9SRVFVRVNURUQiLCJjb250ZXh0IiwiZGF0YSIsInR5cGUiLCJ1c2VyRmxvdyIsImNhbmNlbCIsIm9uU3VjY2VzcyIsIkFDQ09VTlRfRkxBR19TVUNDRVNTX1JFUVVFU1RFRCIsIm9uUXVpdCIsIkFDQ09VTlRfRkxBR19RVUlUX1JFUVVFU1RFRCIsIm9uTG9naW5SZXF1ZXN0ZWQiLCJMT0dJTl9SRVFVRVNURUQiLCJvbkFjdGlvblJlcXVlc3RlZCIsImlzQ2xvc2VSZXF1aXJlZCIsImV4ZWN1dGVMb2dpbiIsInRva2VuIiwidG9rZW5Mb2dJbiIsInN1Y2Nlc3NFdmVudCIsImNvZGUiLCJIQVJEX0ZMQUdfUkVRVUVTVEVEIiwiZW52aXJvbm1lbnQiLCJsb2NhbGUiLCJzb3VyY2UiLCJuYW1lIiwiYXBwIiwic2V0dGluZ3MiLCJvcHRpb25zIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUtBLEtBQVosTUFBdUIsT0FBdkI7QUFDQSxPQUFPLEtBQUtDLFFBQVosTUFBMEIsV0FBMUI7QUFDQSxTQUNFQyx5QkFERixFQUVFQyx5QkFGRixFQUdFQyx5QkFIRixRQU1PLGdEQU5QO0FBT0EsU0FBU0MsaUJBQVQsUUFBa0MsNkNBQWxDO0FBQ0EsU0FBU0MsWUFBVCxFQUF1QkMsaUJBQXZCLFFBQWdELGFBQWhEO0FBQ0EsU0FBU0MscUJBQVQsUUFBc0MseUJBQXRDO0FBRUEsT0FBTyxjQUFQO0FBRUEsV0FBYUMsZ0JBQWI7QUFBQTs7QUFBQTs7QUFPRSw0QkFBWUMsTUFBWixFQUE0Q0MsWUFBNUMsRUFBd0Y7QUFBQTs7QUFBQTs7QUFDdEY7O0FBRHNGOztBQUFBOztBQUFBLDREQUo3Q1IseUJBQXlCLENBQUNTLElBSW1COztBQUFBOztBQUFBLDhEQUZsRCxJQUVrRDs7QUFHdEYsVUFBS0YsTUFBTCxHQUFjQSxNQUFkO0FBQ0EsVUFBS0MsWUFBTCxHQUFvQkEsWUFBcEI7QUFKc0Y7QUFLdkY7O0FBWkg7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLDhGQWtCcUJFLE9BbEJyQjtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxxQkFtQlFOLGlCQUFpQixDQUFDLEtBQUtHLE1BQUwsQ0FBWUksWUFBYixDQUFqQixDQUE0Q0MsUUFBNUMsQ0FBcURGLE9BQU8sQ0FBQ0csSUFBN0QsQ0FuQlI7QUFBQTtBQUFBO0FBQUE7O0FBQUEsa0RBb0JhLEVBcEJiOztBQUFBO0FBQUEsc0JBdUJRLEtBQUtDLEtBQUwsS0FBZWQseUJBQXlCLENBQUNTLElBdkJqRDtBQUFBO0FBQUE7QUFBQTs7QUFBQSxzQkF3Qlk7QUFBRU0sa0JBQUFBLEtBQUssRUFBRWQseUJBQXlCLENBQUNlO0FBQW5DLGlCQXhCWjs7QUFBQTtBQTJCVUMsZ0JBQUFBLGVBM0JWLEdBMkI0QmQsWUFBWSxDQUFDLEtBQUtJLE1BQUwsQ0FBWUksWUFBYixDQUFaLENBQXVDTyxjQUF2QyxDQUFzRFIsT0FBTyxDQUFDRyxJQUE5RCxDQTNCNUI7O0FBQUEsb0JBNkJTSSxlQTdCVDtBQUFBO0FBQUE7QUFBQTs7QUFBQSxzQkE4Qlk7QUFBRUYsa0JBQUFBLEtBQUssRUFBRWQseUJBQXlCLENBQUNlO0FBQW5DLGlCQTlCWjs7QUFBQTtBQWlDSSx1Q0FBQUcsTUFBTSxDQUFDQyxXQUFQLHFHQUFvQkMsSUFBcEIsMEdBQTJCLHdCQUEzQjtBQUNBLHFCQUFLQyxNQUFMLENBQVlaLE9BQVo7QUFDQSxxQkFBS2EsUUFBTCxDQUFjdkIseUJBQXlCLENBQUN3QixPQUF4QztBQW5DSixrREFxQ1csRUFyQ1g7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsc0JBeUNRLEtBQUtWLEtBQUwsS0FBZWQseUJBQXlCLENBQUNTLElBQXpDLElBQWlELEtBQUtnQixPQUFMLEtBQWlCLElBekMxRTtBQUFBO0FBQUE7QUFBQTs7QUFBQSxzQkEwQ1k7QUFBRVYsa0JBQUFBLEtBQUssRUFBRWQseUJBQXlCLENBQUNlO0FBQW5DLGlCQTFDWjs7QUFBQTtBQTZDSWxCLGdCQUFBQSxRQUFRLENBQUM0QixzQkFBVCxDQUFnQyxLQUFLRCxPQUFyQztBQUNBRSxnQkFBQUEsUUFBUSxDQUFDQyxJQUFULENBQWNDLFdBQWQsQ0FBMEIsS0FBS0osT0FBL0I7QUFDQSxxQkFBS0EsT0FBTCxHQUFlLElBQWY7QUFDQSxxQkFBS0YsUUFBTCxDQUFjdkIseUJBQXlCLENBQUNTLElBQXhDO0FBaERKLGtEQWtEVyxFQWxEWDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxrREFzRFc7QUFBRUssa0JBQUFBLEtBQUssRUFBRSxLQUFLQTtBQUFkLGlCQXREWDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxtQ0F5RHdCZ0IsUUF6RHhCLEVBeUQwRTtBQUN0RSxXQUFLQyxzQkFBTCxHQUE4QkQsUUFBOUI7QUFDRDtBQTNESDtBQUFBO0FBQUEsMkJBNkRpQnBCLE9BN0RqQixFQTZEbUQ7QUFBQTs7QUFDL0MsV0FBS2UsT0FBTCxHQUFlRSxRQUFRLENBQUNLLGFBQVQsQ0FBdUIsS0FBdkIsQ0FBZjtBQUNBTCxNQUFBQSxRQUFRLENBQUNDLElBQVQsQ0FBY0ssV0FBZCxDQUEwQixLQUFLUixPQUEvQjtBQUVBLFVBQU1TLFVBQVUsR0FBRy9CLFlBQVksQ0FBQyxLQUFLSSxNQUFMLENBQVlJLFlBQWIsQ0FBWixDQUF1Q0QsT0FBTyxDQUFDRyxJQUEvQyxDQUFuQjs7QUFDQSxVQUFNc0IsT0FBTyxHQUFHLFNBQVZBLE9BQVUsR0FBTTtBQUNwQixRQUFBLE1BQUksQ0FBQzNCLFlBQUwsQ0FBa0IsaUJBQWxCLEVBQXFDNEIsT0FBckMsQ0FBNkM7QUFDM0NDLFVBQUFBLE9BQU8sRUFBRW5DLGlCQUFpQixDQUFDb0MsNEJBRGdCO0FBRTNDQyxVQUFBQSxPQUFPLEVBQUU7QUFDUEMsWUFBQUEsSUFBSSxFQUFFO0FBQ0ozQixjQUFBQSxJQUFJLEVBQUVILE9BQU8sQ0FBQ0csSUFEVjtBQUVKNEIsY0FBQUEsSUFBSSxFQUFFUCxVQUFVLENBQUNPO0FBRmIsYUFEQztBQUtQQyxZQUFBQSxRQUFRLEVBQUU7QUFMSDtBQUZrQyxTQUE3Qzs7QUFVQSxRQUFBLE1BQUksQ0FBQ0MsTUFBTDtBQUNELE9BWkQ7O0FBYUEsVUFBTUMsU0FBUyxHQUFHLFNBQVpBLFNBQVksR0FBTTtBQUN0QixRQUFBLE1BQUksQ0FBQ3BDLFlBQUwsQ0FBa0IsaUJBQWxCLEVBQXFDNEIsT0FBckMsQ0FBNkM7QUFDM0NDLFVBQUFBLE9BQU8sRUFBRW5DLGlCQUFpQixDQUFDMkMsOEJBRGdCO0FBRTNDTixVQUFBQSxPQUFPLEVBQUU7QUFDUEMsWUFBQUEsSUFBSSxFQUFFO0FBQ0ozQixjQUFBQSxJQUFJLEVBQUVILE9BQU8sQ0FBQ0csSUFEVjtBQUVKNEIsY0FBQUEsSUFBSSxFQUFFUCxVQUFVLENBQUNPO0FBRmIsYUFEQztBQUtQQyxZQUFBQSxRQUFRLEVBQUU7QUFMSDtBQUZrQyxTQUE3Qzs7QUFVQSxRQUFBLE1BQUksQ0FBQ0MsTUFBTDtBQUNELE9BWkQ7O0FBYUEsVUFBTUcsTUFBTSxHQUFHLFNBQVRBLE1BQVMsR0FBTTtBQUNuQixRQUFBLE1BQUksQ0FBQ3RDLFlBQUwsQ0FBa0IsaUJBQWxCLEVBQXFDNEIsT0FBckMsQ0FBNkM7QUFDM0NDLFVBQUFBLE9BQU8sRUFBRW5DLGlCQUFpQixDQUFDNkMsMkJBRGdCO0FBRTNDUixVQUFBQSxPQUFPLEVBQUU7QUFDUEMsWUFBQUEsSUFBSSxFQUFFO0FBQ0ozQixjQUFBQSxJQUFJLEVBQUVILE9BQU8sQ0FBQ0csSUFEVjtBQUVKNEIsY0FBQUEsSUFBSSxFQUFFUCxVQUFVLENBQUNPO0FBRmIsYUFEQztBQUtQQyxZQUFBQSxRQUFRLEVBQUU7QUFMSDtBQUZrQyxTQUE3Qzs7QUFVQSxRQUFBLE1BQUksQ0FBQ0MsTUFBTDtBQUNELE9BWkQ7O0FBYUEsVUFBTUssZ0JBQWdCLEdBQUcsU0FBbkJBLGdCQUFtQixHQUFNO0FBQzdCLFFBQUEsTUFBSSxDQUFDeEMsWUFBTCxDQUFrQixpQkFBbEIsRUFBcUM0QixPQUFyQyxDQUE2QztBQUMzQ0MsVUFBQUEsT0FBTyxFQUFFbkMsaUJBQWlCLENBQUMrQyxlQURnQjtBQUUzQ1YsVUFBQUEsT0FBTyxFQUFFO0FBQUVHLFlBQUFBLFFBQVEsRUFBRTtBQUFaO0FBRmtDLFNBQTdDOztBQUlBLFFBQUEsTUFBSSxDQUFDQyxNQUFMO0FBQ0QsT0FORDs7QUFPQSxVQUFNTyxpQkFBb0MsR0FBRyxTQUF2Q0EsaUJBQXVDLENBQUNiLE9BQUQsRUFBVUUsT0FBVixFQUE4QztBQUFBLFlBQTNCWSxlQUEyQix1RUFBVCxJQUFTOztBQUN6RixRQUFBLE1BQUksQ0FBQzNDLFlBQUwsQ0FBa0IsaUJBQWxCLEVBQXFDNEIsT0FBckMsQ0FBNkM7QUFDM0NDLFVBQUFBLE9BQU8sRUFBUEEsT0FEMkM7QUFFM0NFLFVBQUFBLE9BQU8scUJBQU9BLE9BQVA7QUFBZ0JHLFlBQUFBLFFBQVEsRUFBRTtBQUExQjtBQUZvQyxTQUE3Qzs7QUFLQSxZQUFJUyxlQUFKLEVBQXFCO0FBQ25CLFVBQUEsTUFBSSxDQUFDUixNQUFMO0FBQ0Q7QUFDRixPQVREOztBQVVBLFVBQU1TLFlBQVk7QUFBQSw0RUFBRyxrQkFBT0MsS0FBUDtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsc0JBQ2RBLEtBRGM7QUFBQTtBQUFBO0FBQUE7O0FBRWpCTCxrQkFBQUEsZ0JBQWdCO0FBRkM7O0FBQUE7QUFBQTtBQUFBO0FBQUEseUJBT1gsTUFBSSxDQUFDeEMsWUFBTCxDQUFrQixpQkFBbEIsRUFBcUM4QyxVQUFyQyxDQUFnRDtBQUFFRCxvQkFBQUEsS0FBSyxFQUFMQTtBQUFGLG1CQUFoRCxDQVBXOztBQUFBO0FBU1RFLGtCQUFBQSxZQVRTLEdBU1FwRCxZQUFZLENBQUMsTUFBSSxDQUFDSSxNQUFMLENBQVlJLFlBQWIsQ0FBWixDQUF1Q0QsT0FBTyxDQUFDRyxJQUEvQyxDQVRSLENBU1QwQyxZQVRTOztBQUFBLHNCQVdaQSxZQVhZO0FBQUE7QUFBQTtBQUFBOztBQUFBOztBQUFBO0FBZWpCLGtCQUFBLE1BQUksQ0FBQy9DLFlBQUwsQ0FBa0IsaUJBQWxCLEVBQXFDNEIsT0FBckMsQ0FBNkM7QUFDM0NDLG9CQUFBQSxPQUFPLEVBQUVrQixZQURrQztBQUUzQ2hCLG9CQUFBQSxPQUFPLEVBQUU7QUFBRUcsc0JBQUFBLFFBQVEsRUFBRTtBQUFaO0FBRmtDLG1CQUE3Qzs7QUFmaUI7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBb0JqQixzQkFBSSwwRkFBTzNCLEtBQVAsOERBQWN5QyxJQUFkLE1BQXVCLGdDQUEzQixFQUE2RDtBQUMzRCxvQkFBQSxNQUFJLENBQUNoRCxZQUFMLENBQWtCLGlCQUFsQixFQUFxQzRCLE9BQXJDLENBQTZDO0FBQzNDQyxzQkFBQUEsT0FBTyxFQUFFbkMsaUJBQWlCLENBQUN1RCxtQkFEZ0I7QUFFM0NsQixzQkFBQUEsT0FBTyxFQUFFO0FBQUVDLHdCQUFBQSxJQUFJLCtFQUFFLGFBQU96QixLQUFULGtEQUFFLGNBQWN5QixJQUF0QjtBQUE0QkUsd0JBQUFBLFFBQVEsRUFBRTtBQUF0QztBQUZrQyxxQkFBN0M7QUFJRCxtQkFMRCxNQUtPO0FBQ0xNLG9CQUFBQSxnQkFBZ0I7QUFDakI7O0FBM0JnQjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxTQUFIOztBQUFBLHdCQUFaSSxZQUFZO0FBQUE7QUFBQTtBQUFBLFNBQWxCOztBQStCQXRELE1BQUFBLFFBQVEsQ0FBQ3dCLE1BQVQsZUFDRSxvQkFBQyxxQkFBRDtBQUNFLFFBQUEsV0FBVyxFQUFFLEtBQUtmLE1BQUwsQ0FBWW1ELFdBRDNCO0FBRUUsUUFBQSxZQUFZLEVBQUUsS0FBS25ELE1BQUwsQ0FBWUksWUFGNUI7QUFHRSxRQUFBLE1BQU0sRUFBRSxLQUFLSixNQUFMLENBQVlvRCxNQUh0QjtBQUlFLFFBQUEsaUJBQWlCLEVBQUUsS0FBS25ELFlBQUwsQ0FBa0IscUJBQWxCLENBSnJCO0FBS0UsUUFBQSxJQUFJLEVBQUU7QUFDSm9ELFVBQUFBLE1BQU0sRUFBRWxELE9BQU8sQ0FBQ0csSUFEWjtBQUVKMEIsVUFBQUEsT0FBTyxFQUFFN0IsT0FBTyxDQUFDNkIsT0FGYjtBQUdKc0IsVUFBQUEsSUFBSSxFQUFFM0IsVUFBVSxDQUFDNEIsR0FIYjtBQUlKckIsVUFBQUEsSUFBSSxFQUFFUCxVQUFVLENBQUNPLElBSmI7QUFLSlksVUFBQUEsS0FBSyxFQUFFM0MsT0FBTyxDQUFDMkMsS0FMWDtBQU1KVSxVQUFBQSxRQUFRLEVBQUU3QixVQUFVLENBQUM2QixRQU5qQjtBQU9KQyxVQUFBQSxPQUFPLEVBQUU5QixVQUFVLENBQUM4QjtBQVBoQixTQUxSO0FBY0UsUUFBQSxPQUFPLEVBQUU3QixPQWRYO0FBZUUsUUFBQSxTQUFTLEVBQUVTLFNBZmI7QUFnQkUsUUFBQSxNQUFNLEVBQUVFLE1BaEJWO0FBaUJFLFFBQUEsZ0JBQWdCLEVBQUVFLGdCQWpCcEI7QUFrQkUsUUFBQSxpQkFBaUIsRUFBRUUsaUJBbEJyQjtBQW1CRSxRQUFBLFlBQVksRUFBRUU7QUFuQmhCLFFBREYsRUFzQkUsS0FBSzNCLE9BdEJQO0FBd0JEO0FBakxIO0FBQUE7QUFBQSw2QkFtTG1CWCxLQW5MbkIsRUFtTHFEO0FBQ2pELFVBQUksS0FBS0EsS0FBTCxLQUFlQSxLQUFuQixFQUEwQjtBQUN4QjtBQUNEOztBQUVELFdBQUtBLEtBQUwsR0FBYUEsS0FBYjs7QUFFQSxVQUFJLEtBQUtpQixzQkFBVCxFQUFpQztBQUMvQixhQUFLQSxzQkFBTCxDQUE0QjtBQUFFakIsVUFBQUEsS0FBSyxFQUFMQTtBQUFGLFNBQTVCO0FBQ0Q7QUFDRjtBQTdMSDs7QUFBQTtBQUFBLEVBQXNDZix5QkFBdEMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgKiBhcyBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgKiBhcyBSZWFjdERPTSBmcm9tICdyZWFjdC1kb20nO1xuaW1wb3J0IHtcbiAgQWNjb3VudEZsYWdzRmxvd0ludGVyZmFjZSxcbiAgQWNjb3VudEZsYWdzRmxvd1N0YXRlVHlwZSxcbiAgQWNjb3VudEZsYWdzRmxvd0Vycm9yVHlwZSxcbiAgQWNjb3VudEZsYWdzRmxvd1BheWxvYWQsXG4gIE9uQWNjb3VudEZsYWdzRmxvd1N0YXRlQ2hhbmdlZENhbGxiYWNrLFxufSBmcm9tICdAY2VudHJhbC1wcm9kdWN0cy9pbnRlcmZhY2UtYWNjb3VudC1mbGFncy1mbG93JztcbmltcG9ydCB7IEFDQ09VTlRfRVZFTlRfSURTIH0gZnJvbSAnQGNlbnRyYWwtcHJvZHVjdHMvaW50ZXJmYWNlLWFjY291bnQtYWN0aW9ucyc7XG5pbXBvcnQgeyBGTEFHU19DT05GSUcsIElORk9fRkxBR1NfQ09ORklHIH0gZnJvbSAnLi9jb25zdGFudHMnO1xuaW1wb3J0IHsgQWNjb3VudEZsYWdzQ29udGFpbmVyIH0gZnJvbSAnLi9BY2NvdW50RmxhZ3NDb250YWluZXInO1xuaW1wb3J0IHsgQWNjb3VudEZsYWdzRmxvd0NvbmZpZywgQWNjb3VudEZsYWdzRmxvd0RlcGVuZGVuY2llcywgT25BY3Rpb25SZXF1ZXN0ZWQgfSBmcm9tICcuL3R5cGVzJztcbmltcG9ydCAnLi9pbmRleC5zY3NzJztcblxuZXhwb3J0IGNsYXNzIEFjY291bnRGbGFnc0Zsb3cgZXh0ZW5kcyBBY2NvdW50RmxhZ3NGbG93SW50ZXJmYWNlIHtcbiAgcHJpdmF0ZSByZWFkb25seSBjb25maWc6IEFjY291bnRGbGFnc0Zsb3dDb25maWc7XG4gIHByaXZhdGUgcmVhZG9ubHkgZGVwZW5kZW5jaWVzOiBBY2NvdW50RmxhZ3NGbG93RGVwZW5kZW5jaWVzO1xuICBwcml2YXRlIHN0YXRlOiBBY2NvdW50RmxhZ3NGbG93U3RhdGVUeXBlID0gQWNjb3VudEZsYWdzRmxvd1N0YXRlVHlwZS5OT05FO1xuICBwcml2YXRlIG9uU3RhdGVDaGFuZ2VkQ2FsbGJhY2s/OiBPbkFjY291bnRGbGFnc0Zsb3dTdGF0ZUNoYW5nZWRDYWxsYmFjaztcbiAgcHJpdmF0ZSBkb21Ob2RlOiBIVE1MRWxlbWVudCB8IG51bGwgPSBudWxsO1xuXG4gIGNvbnN0cnVjdG9yKGNvbmZpZzogQWNjb3VudEZsYWdzRmxvd0NvbmZpZywgZGVwZW5kZW5jaWVzOiBBY2NvdW50RmxhZ3NGbG93RGVwZW5kZW5jaWVzKSB7XG4gICAgc3VwZXIoKTtcblxuICAgIHRoaXMuY29uZmlnID0gY29uZmlnO1xuICAgIHRoaXMuZGVwZW5kZW5jaWVzID0gZGVwZW5kZW5jaWVzO1xuICB9XG5cbiAgcHVibGljIGFzeW5jIGluaXQoKSB7XG4gICAgLy8gVE9ETzogY2FuY2VsIGRpc3BsYXlpbmcgdGhlIHNvZnQgZmxhZyBhZnRlciBsb2dvdXQgd2hpY2ggY2FuIGhhcHBlbiBpbiB0aGUgYmFja2dyb3VuZFxuICB9XG5cbiAgcHVibGljIGFzeW5jIHN0YXJ0KHBheWxvYWQ6IEFjY291bnRGbGFnc0Zsb3dQYXlsb2FkKSB7XG4gICAgaWYgKElORk9fRkxBR1NfQ09ORklHW3RoaXMuY29uZmlnLmp1cmlzZGljdGlvbl0uaW5jbHVkZXMocGF5bG9hZC5mbGFnKSkge1xuICAgICAgcmV0dXJuIHt9O1xuICAgIH1cblxuICAgIGlmICh0aGlzLnN0YXRlICE9PSBBY2NvdW50RmxhZ3NGbG93U3RhdGVUeXBlLk5PTkUpIHtcbiAgICAgIHRocm93IHsgZXJyb3I6IEFjY291bnRGbGFnc0Zsb3dFcnJvclR5cGUuSU5WQUxJRF9TVEFURSB9O1xuICAgIH1cblxuICAgIGNvbnN0IGlzRmxhZ1N1cHBvcnRlZCA9IEZMQUdTX0NPTkZJR1t0aGlzLmNvbmZpZy5qdXJpc2RpY3Rpb25dLmhhc093blByb3BlcnR5KHBheWxvYWQuZmxhZyk7XG5cbiAgICBpZiAoIWlzRmxhZ1N1cHBvcnRlZCkge1xuICAgICAgdGhyb3cgeyBlcnJvcjogQWNjb3VudEZsYWdzRmxvd0Vycm9yVHlwZS5JTlZBTElEX1NUQVRFIH07XG4gICAgfVxuXG4gICAgd2luZG93LnBlcmZvcm1hbmNlPy5tYXJrPy4oJ2NwOmFjY291bnQtZmxhZ3M6c3RhcnQnKTtcbiAgICB0aGlzLnJlbmRlcihwYXlsb2FkKTtcbiAgICB0aGlzLnNldFN0YXRlKEFjY291bnRGbGFnc0Zsb3dTdGF0ZVR5cGUuU1RBUlRFRCk7XG5cbiAgICByZXR1cm4ge307XG4gIH1cblxuICBwdWJsaWMgYXN5bmMgY2FuY2VsKCkge1xuICAgIGlmICh0aGlzLnN0YXRlID09PSBBY2NvdW50RmxhZ3NGbG93U3RhdGVUeXBlLk5PTkUgfHwgdGhpcy5kb21Ob2RlID09PSBudWxsKSB7XG4gICAgICB0aHJvdyB7IGVycm9yOiBBY2NvdW50RmxhZ3NGbG93RXJyb3JUeXBlLklOVkFMSURfU1RBVEUgfTtcbiAgICB9XG5cbiAgICBSZWFjdERPTS51bm1vdW50Q29tcG9uZW50QXROb2RlKHRoaXMuZG9tTm9kZSk7XG4gICAgZG9jdW1lbnQuYm9keS5yZW1vdmVDaGlsZCh0aGlzLmRvbU5vZGUpO1xuICAgIHRoaXMuZG9tTm9kZSA9IG51bGw7XG4gICAgdGhpcy5zZXRTdGF0ZShBY2NvdW50RmxhZ3NGbG93U3RhdGVUeXBlLk5PTkUpO1xuXG4gICAgcmV0dXJuIHt9O1xuICB9XG5cbiAgcHVibGljIGFzeW5jIGdldFN0YXRlKCkge1xuICAgIHJldHVybiB7IHN0YXRlOiB0aGlzLnN0YXRlIH07XG4gIH1cblxuICBwdWJsaWMgb25TdGF0ZUNoYW5nZWQoY2FsbGJhY2s6IE9uQWNjb3VudEZsYWdzRmxvd1N0YXRlQ2hhbmdlZENhbGxiYWNrKSB7XG4gICAgdGhpcy5vblN0YXRlQ2hhbmdlZENhbGxiYWNrID0gY2FsbGJhY2s7XG4gIH1cblxuICBwcml2YXRlIHJlbmRlcihwYXlsb2FkOiBBY2NvdW50RmxhZ3NGbG93UGF5bG9hZCkge1xuICAgIHRoaXMuZG9tTm9kZSA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoJ2RpdicpO1xuICAgIGRvY3VtZW50LmJvZHkuYXBwZW5kQ2hpbGQodGhpcy5kb21Ob2RlKTtcblxuICAgIGNvbnN0IGZsYWdDb25maWcgPSBGTEFHU19DT05GSUdbdGhpcy5jb25maWcuanVyaXNkaWN0aW9uXVtwYXlsb2FkLmZsYWddO1xuICAgIGNvbnN0IG9uQ2xvc2UgPSAoKSA9PiB7XG4gICAgICB0aGlzLmRlcGVuZGVuY2llc1snYWNjb3VudC1hY3Rpb25zJ10uZXhlY3V0ZSh7XG4gICAgICAgIGV2ZW50SWQ6IEFDQ09VTlRfRVZFTlRfSURTLkFDQ09VTlRfRkxBR19DTE9TRV9SRVFVRVNURUQsXG4gICAgICAgIGNvbnRleHQ6IHtcbiAgICAgICAgICBkYXRhOiB7XG4gICAgICAgICAgICBmbGFnOiBwYXlsb2FkLmZsYWcsXG4gICAgICAgICAgICB0eXBlOiBmbGFnQ29uZmlnLnR5cGUsXG4gICAgICAgICAgfSxcbiAgICAgICAgICB1c2VyRmxvdzogJ2FjY291bnQtZmxhZ3MnLFxuICAgICAgICB9LFxuICAgICAgfSk7XG4gICAgICB0aGlzLmNhbmNlbCgpO1xuICAgIH07XG4gICAgY29uc3Qgb25TdWNjZXNzID0gKCkgPT4ge1xuICAgICAgdGhpcy5kZXBlbmRlbmNpZXNbJ2FjY291bnQtYWN0aW9ucyddLmV4ZWN1dGUoe1xuICAgICAgICBldmVudElkOiBBQ0NPVU5UX0VWRU5UX0lEUy5BQ0NPVU5UX0ZMQUdfU1VDQ0VTU19SRVFVRVNURUQsXG4gICAgICAgIGNvbnRleHQ6IHtcbiAgICAgICAgICBkYXRhOiB7XG4gICAgICAgICAgICBmbGFnOiBwYXlsb2FkLmZsYWcsXG4gICAgICAgICAgICB0eXBlOiBmbGFnQ29uZmlnLnR5cGUsXG4gICAgICAgICAgfSxcbiAgICAgICAgICB1c2VyRmxvdzogJ2FjY291bnQtZmxhZ3MnLFxuICAgICAgICB9LFxuICAgICAgfSk7XG4gICAgICB0aGlzLmNhbmNlbCgpO1xuICAgIH07XG4gICAgY29uc3Qgb25RdWl0ID0gKCkgPT4ge1xuICAgICAgdGhpcy5kZXBlbmRlbmNpZXNbJ2FjY291bnQtYWN0aW9ucyddLmV4ZWN1dGUoe1xuICAgICAgICBldmVudElkOiBBQ0NPVU5UX0VWRU5UX0lEUy5BQ0NPVU5UX0ZMQUdfUVVJVF9SRVFVRVNURUQsXG4gICAgICAgIGNvbnRleHQ6IHtcbiAgICAgICAgICBkYXRhOiB7XG4gICAgICAgICAgICBmbGFnOiBwYXlsb2FkLmZsYWcsXG4gICAgICAgICAgICB0eXBlOiBmbGFnQ29uZmlnLnR5cGUsXG4gICAgICAgICAgfSxcbiAgICAgICAgICB1c2VyRmxvdzogJ2FjY291bnQtZmxhZ3MnLFxuICAgICAgICB9LFxuICAgICAgfSk7XG4gICAgICB0aGlzLmNhbmNlbCgpO1xuICAgIH07XG4gICAgY29uc3Qgb25Mb2dpblJlcXVlc3RlZCA9ICgpID0+IHtcbiAgICAgIHRoaXMuZGVwZW5kZW5jaWVzWydhY2NvdW50LWFjdGlvbnMnXS5leGVjdXRlKHtcbiAgICAgICAgZXZlbnRJZDogQUNDT1VOVF9FVkVOVF9JRFMuTE9HSU5fUkVRVUVTVEVELFxuICAgICAgICBjb250ZXh0OiB7IHVzZXJGbG93OiAnYWNjb3VudC1mbGFncycgfSxcbiAgICAgIH0pO1xuICAgICAgdGhpcy5jYW5jZWwoKTtcbiAgICB9O1xuICAgIGNvbnN0IG9uQWN0aW9uUmVxdWVzdGVkOiBPbkFjdGlvblJlcXVlc3RlZCA9IChldmVudElkLCBjb250ZXh0LCBpc0Nsb3NlUmVxdWlyZWQgPSB0cnVlKSA9PiB7XG4gICAgICB0aGlzLmRlcGVuZGVuY2llc1snYWNjb3VudC1hY3Rpb25zJ10uZXhlY3V0ZSh7XG4gICAgICAgIGV2ZW50SWQsXG4gICAgICAgIGNvbnRleHQ6IHsgLi4uY29udGV4dCwgdXNlckZsb3c6ICdhY2NvdW50LWZsYWdzJyB9LFxuICAgICAgfSk7XG5cbiAgICAgIGlmIChpc0Nsb3NlUmVxdWlyZWQpIHtcbiAgICAgICAgdGhpcy5jYW5jZWwoKTtcbiAgICAgIH1cbiAgICB9O1xuICAgIGNvbnN0IGV4ZWN1dGVMb2dpbiA9IGFzeW5jICh0b2tlbj86IHN0cmluZyk6IFByb21pc2U8dm9pZD4gPT4ge1xuICAgICAgaWYgKCF0b2tlbikge1xuICAgICAgICBvbkxvZ2luUmVxdWVzdGVkKCk7XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cblxuICAgICAgdHJ5IHtcbiAgICAgICAgYXdhaXQgdGhpcy5kZXBlbmRlbmNpZXNbJ3Nlc3Npb24tbWFuYWdlciddLnRva2VuTG9nSW4oeyB0b2tlbiB9KTtcblxuICAgICAgICBjb25zdCB7IHN1Y2Nlc3NFdmVudCB9ID0gRkxBR1NfQ09ORklHW3RoaXMuY29uZmlnLmp1cmlzZGljdGlvbl1bcGF5bG9hZC5mbGFnXTtcblxuICAgICAgICBpZiAoIXN1Y2Nlc3NFdmVudCkge1xuICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuXG4gICAgICAgIHRoaXMuZGVwZW5kZW5jaWVzWydhY2NvdW50LWFjdGlvbnMnXS5leGVjdXRlKHtcbiAgICAgICAgICBldmVudElkOiBzdWNjZXNzRXZlbnQsXG4gICAgICAgICAgY29udGV4dDogeyB1c2VyRmxvdzogJ2FjY291bnQtZmxhZ3MnIH0sXG4gICAgICAgIH0pO1xuICAgICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgICAgaWYgKGVycm9yPy5lcnJvcj8uY29kZSA9PT0gJ2Vycm9yLmF1dGhlbnRpY2F0aW9uLmhhcmQuZmxhZycpIHtcbiAgICAgICAgICB0aGlzLmRlcGVuZGVuY2llc1snYWNjb3VudC1hY3Rpb25zJ10uZXhlY3V0ZSh7XG4gICAgICAgICAgICBldmVudElkOiBBQ0NPVU5UX0VWRU5UX0lEUy5IQVJEX0ZMQUdfUkVRVUVTVEVELFxuICAgICAgICAgICAgY29udGV4dDogeyBkYXRhOiBlcnJvcj8uZXJyb3I/LmRhdGEsIHVzZXJGbG93OiAnYWNjb3VudC1mbGFncycgfSxcbiAgICAgICAgICB9KTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICBvbkxvZ2luUmVxdWVzdGVkKCk7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9O1xuXG4gICAgUmVhY3RET00ucmVuZGVyKFxuICAgICAgPEFjY291bnRGbGFnc0NvbnRhaW5lclxuICAgICAgICBlbnZpcm9ubWVudD17dGhpcy5jb25maWcuZW52aXJvbm1lbnR9XG4gICAgICAgIGp1cmlzZGljdGlvbj17dGhpcy5jb25maWcuanVyaXNkaWN0aW9ufVxuICAgICAgICBsb2NhbGU9e3RoaXMuY29uZmlnLmxvY2FsZX1cbiAgICAgICAgZGF0YUFjY2Vzc1NlcnZpY2U9e3RoaXMuZGVwZW5kZW5jaWVzWydkYXRhLWFjY2Vzcy1zZXJ2aWNlJ119XG4gICAgICAgIGZsYWc9e3tcbiAgICAgICAgICBzb3VyY2U6IHBheWxvYWQuZmxhZyxcbiAgICAgICAgICBjb250ZXh0OiBwYXlsb2FkLmNvbnRleHQsXG4gICAgICAgICAgbmFtZTogZmxhZ0NvbmZpZy5hcHAsXG4gICAgICAgICAgdHlwZTogZmxhZ0NvbmZpZy50eXBlLFxuICAgICAgICAgIHRva2VuOiBwYXlsb2FkLnRva2VuLFxuICAgICAgICAgIHNldHRpbmdzOiBmbGFnQ29uZmlnLnNldHRpbmdzLFxuICAgICAgICAgIG9wdGlvbnM6IGZsYWdDb25maWcub3B0aW9ucyxcbiAgICAgICAgfX1cbiAgICAgICAgb25DbG9zZT17b25DbG9zZX1cbiAgICAgICAgb25TdWNjZXNzPXtvblN1Y2Nlc3N9XG4gICAgICAgIG9uUXVpdD17b25RdWl0fVxuICAgICAgICBvbkxvZ2luUmVxdWVzdGVkPXtvbkxvZ2luUmVxdWVzdGVkfVxuICAgICAgICBvbkFjdGlvblJlcXVlc3RlZD17b25BY3Rpb25SZXF1ZXN0ZWR9XG4gICAgICAgIGV4ZWN1dGVMb2dpbj17ZXhlY3V0ZUxvZ2lufVxuICAgICAgLz4sXG4gICAgICB0aGlzLmRvbU5vZGVcbiAgICApO1xuICB9XG5cbiAgcHJpdmF0ZSBzZXRTdGF0ZShzdGF0ZTogQWNjb3VudEZsYWdzRmxvd1N0YXRlVHlwZSkge1xuICAgIGlmICh0aGlzLnN0YXRlID09PSBzdGF0ZSkge1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIHRoaXMuc3RhdGUgPSBzdGF0ZTtcblxuICAgIGlmICh0aGlzLm9uU3RhdGVDaGFuZ2VkQ2FsbGJhY2spIHtcbiAgICAgIHRoaXMub25TdGF0ZUNoYW5nZWRDYWxsYmFjayh7IHN0YXRlIH0pO1xuICAgIH1cbiAgfVxufVxuIl19